<template>
    <div class="report__filters">
        <base-filter
            :select-items="filters"
            :select-inline="true"
            :sort-active="false"
            :actions-active="true"
            :actions-primary-button-active="false"
            :actions-secondary-button-text="$t('ebs.reports.buttons.exportCSV')"
            :actions-secondary-button-animate-loading="true"
            :list-active="false"
            :select-button-animate-loading-name="`filter-select-${reportType}`"
            @emit-filter-select="setFilter"
            @emit-actions-secondary="getReportCSV"
            @emit-filter-select-button="getReportTable"
        />
        <a
            class="report__filters_hiddenlink hidden"
            id="download-report-csv"
        ></a>
    </div>
</template>

<script>
import BaseFilter from '@/components/default/filters/BaseFilter'
export default {
  name: 'report-filters',
  components: { BaseFilter },
  props: {
    filters: {
      type: [Array, String],
      required: true
    },
    reportType: {
      type: String
    },
    getReportTableDispatch: {
      type: String
    },
    getReportCsvDispatch: {
      type: String
    },
    setFiltersFetchDispatch: {
      type: String
    },
    getFiltersFetchDispatch: {
      type: String
    }
  },
  methods: {
    setFilter (data) {
      this.$store.dispatch(this.setFiltersFetchDispatch, data)
    },
    getReportTable () {
      this.$eventBus.$emit(`start-loading-report-${this.reportType}`)
      this.$store.dispatch(this.getReportTableDispatch, this.reportType).finally(() => {
        this.$eventBus.$emit(`stop-loading-report-${this.reportType}`)
        this.$eventBus.$emit(`stop-filter-select-${this.reportType}`)
      })
    },
    getReportCSV () {
      this.$store.dispatch(this.getReportCsvDispatch, this.reportType)
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/reports/reportfilters";
</style>
